// extracted by mini-css-extract-plugin
module.exports = {"active":"style__active__kykTY"};